import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useHistory } from "react-router-dom";
import UserService from '../../services/UserService';
import AuthService from '../../services/auth.services';
import { useJwt } from "react-jwt";
// import { Modal } from '../dashboard/Modal';
import Modal from 'react-modal';
import { GlobalStyle } from '../../styles/modalStyles';
import styled from 'styled-components';
import '../../modal.css';
import settings from '../../services/Settings';

function RegisterSuccessfulComponent({closeModal}) {
  const history = useHistory();

  return (
    <div className="modal-dialog modal-confirm">
    <div className="modal-content">
        <div className="modal-header">
            <div className="icon-box">
            <i className="fa fa-check" aria-hidden="true"></i>
            </div>				
            <h4 className="modal-title">Awesome!</h4>	
        </div>
        <div className="modal-body">
            <p className="text-center">Your registration was successful.</p>
        </div>
        <div className="modal-footer">
            <button className="btn btn-success btn-block" data-dismiss="modal" onClick={() => history.push("/newsfeed")}>Go To Newsfeed</button>
            <button className="btn " data-dismiss="modal" onClick={closeModal} style={{marginRight: '35%', backgroundColor: '#e25b5b'}}>Close</button>
        </div>
    </div>
</div>
  );
}
export default RegisterSuccessfulComponent;